import { authApi } from "@/api/veos/";

/**
 * Services utilisateur
 */
export default class UserService {

  /**
   * Fonction de connexion
   * @param {string} uid le login
   * @param {string} passwd le mot de passe
   * @return {Promise<any>} la promesse
   */
  public async login(uid: string, passwd: string): Promise<any> {
    const response = await authApi.login({ uid, passwd });
    if (response.data.token) {
      localStorage.setItem(`${process.env.VUE_APP_TOKEN}`, JSON.stringify(response.data.token));
    }
    return response.data;
  }

  /**
   * Fonction de déconnexion
   * @return {void}
   */
  public logout(): void {
    localStorage.removeItem(`${process.env.VUE_APP_TOKEN}`);
    localStorage.removeItem(`${process.env.VUE_APP_PARAM}`);
  }

}
